import { AnnulledPrescription, ValidatedPrescription } from '../types';

export const isPrescriptionValidated = (
   prescription: ValidatedPrescription | AnnulledPrescription
): prescription is ValidatedPrescription => {
   return !prescription.annulled;
};
